import { CommonTheme, ManualCSSTheme } from 'app/shared/theme';

type CssProp = string | number;

export interface GenerateCssPropForScreenSizeProps {
  theme: CommonTheme | ManualCSSTheme;
  screenSize: string;
  propName: string;
  value: CssProp | CssProp[] | undefined;
  generateCssProperty: (
    theme: CommonTheme | ManualCSSTheme,
    propName: string,
    value: CssProp
  ) => string;
}

export const generateCSSPropForScreenSize = ({
  theme,
  screenSize,
  propName,
  value,
  generateCssProperty,
}: GenerateCssPropForScreenSizeProps) => {
  if (Array.isArray(value) && value.length > 0) {
    let styles: string[] = [];
    const breakpointIndex = Object.keys(theme.media).indexOf(screenSize);

    if (breakpointIndex >= 0) {
      const valueForBreakpoint = value[breakpointIndex];

      if (valueForBreakpoint || valueForBreakpoint === 0) {
        styles.push(generateCssProperty(theme, propName, valueForBreakpoint));
      }
    }

    return styles;
  }

  if (value || value === 0) {
    return generateCssProperty(theme, propName, value as string | number);
  }

  return '';
};
